import React from "react";
import { useTranslation } from "react-i18next";
import { supportedLngs } from "./config";
import FloatingInputLabel from "../components/editable/EditableField/components/FloatingInputLabel";
import { MenuItem, Select } from "@mui/material";


export default function LocaleSwitcher() {
  const { i18n, t } = useTranslation();

  return (
    <FloatingInputLabel label={t("general.language")}>
      <Select
        id="locale"
        name="locale"
        value={i18n.resolvedLanguage}
        onChange={(e) => i18n.changeLanguage(e.target.value as string)}
        fullWidth
        style={{
          overflow: "hidden",
          borderRadius: "5px",
          textAlign: 'left',
          padding: 0,
          cursor: 'pointer',
          height: '40px'
        }}               >
        {Object.entries(supportedLngs).map(([code, name]) => (
          <MenuItem value={code} key={code}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FloatingInputLabel>
  );
}
